<template>
  <div id="app">
    <preloader v-show="showLoader"/>

    <component :is="getLayoutName">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import page from '@/mixins/page'
import pastCode from '@/mixins/pastCode'
import wsWorker from '@/mixins/wsWorker'

import DefaultLayout from '@/layouts/default'
import ClearLayout from '@/layouts/clear'
import Preloader from '@/components/preloader'

export default {
  name: 'Main',
  mixins: [page, pastCode, wsWorker],
  components: {
    DefaultLayout,
    ClearLayout,
    Preloader
  },
  data () {
    return {
      showLoader: false,
      lastTime: 0,
      isManualClosedConnect: false,
      connectWSChallengeInterval: null,
      countDownPingInterval: null
    }
  },
  computed: {
    ...mapGetters('user', ['isAuth']),
    ...mapGetters('workingShift', ['getOpenedWorkingShift']),
    ...mapGetters('settings', ['getLinks']),
    ...mapGetters('config', ['getIsOffline']),
    ...mapGetters('modal', ['getOpenedModals']),
    getLayoutName () {
      return this.$route.meta?.layout || 'DefaultLayout'
    }
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler(_, oldValue) {
        if (oldValue === 'auth') {
          this.loadCriticalData()
        }

        document.title = `Master CRM - ${this.getPageTitle}`
      }
    },
  },
  async created () {
    this.$bus.on('start-loader', this.startLoader)
    this.$bus.on('stop-loader', this.stopLoader)

    await this.loadCriticalData()
  },
  beforeDestroy() {
    this.$bus.off('start-loader', this.startLoader)
    this.$bus.off('stop-loader', this.stopLoader)
  },
  methods: {
    ...mapActions('user', { loadDataUser: 'loadData' }),
    ...mapActions('users', { loadDataUsers: 'loadData' }),
    ...mapActions('settings', { loadMainSettings: 'loadMainData' }),
    ...mapActions('workingShift', { loadWorkingShift: 'loadData' }),
    ...mapActions('product', { loadProducts: 'loadData' }),
    async loadCriticalData () {
      if (this.$route.name === 'auth' || !this.isAuth) {
        return
      }

      await this.$bus.emit('start-loader')
      // Загрузим первоначальные данные
      // Данные о пользователе и настройки
      await Promise.all([
        await this.loadDataUser(),
        await this.loadDataUsers(),
        await this.loadMainSettings(),
        await this.loadWorkingShift(),
        await this.loadProducts(),
      ])

      setTimeout(() => {
        this.$bus.emit('stop-loader')
      }, 100)
    },
    startLoader () {
      this.showLoader = true
      document.getElementsByTagName('html')[0].classList.add('overflow-hidden')
    },
    stopLoader () {
      this.showLoader = false

      if (this.getOpenedModals.length > 0) {
        return
      }

      document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
    }
  }
}
</script>

<style>
@import "assets/styles/main.scss";
@import "assets/styles/form.scss";
</style>
